import {MultiAllocationDataSourceRecord} from "src/models/multidimensional-allocation/MultiAllocationDataSourceRecord";
import {
    getEmptyLOVs,
    MultidimensionalAllocationLOV
} from "src/models/multidimensional-allocation/MultidimensionalAllocationLOV";
import {MultiAllocationSheetData} from "src/models/multidimensional-allocation/MultiAllocationSheetData";

export interface MultidimensionalAllocationDataSourcesState {
    datasetRecords: MultiAllocationDataSourceRecord[],
    loading: boolean,
    showDecimals: boolean,
    recordIdCounter: number,
    customCoaReference?: Map<string, string>,
    recordBeingEdited?: MultiAllocationDataSourceRecord,
    recordBeingEditedOriginal?: MultiAllocationDataSourceRecord,
    coaTypes: string[],
    recordIdForAction: string,
    refreshBalanceStatusDatasourceId?: string,
    showEditActionConfirmModal: boolean,
    showDuplicateActionConfirmModal: boolean,
    showDeleteActionConfirmModal: boolean,
    multidimensionalAllocationLOV: MultidimensionalAllocationLOV,
    error?: string,
    savedRecordId?: string,
    deleteDataSourcePayload?: any,
    selectedCustomCoaValues?: Map<string, string>,
    allocationSheets: MultiAllocationSheetData[],
    filteredAllocationSheets: MultiAllocationSheetData[],
    allocationSheetsLoading: boolean,
}

export const initialState: MultidimensionalAllocationDataSourcesState = {
    datasetRecords: [],
    loading: true,
    showDecimals: false,
    recordIdCounter: 0,
    coaTypes: [],
    recordIdForAction: "-1",
    showEditActionConfirmModal: false,
    showDuplicateActionConfirmModal: false,
    showDeleteActionConfirmModal: false,
    multidimensionalAllocationLOV: getEmptyLOVs(),
    allocationSheets: [],
    filteredAllocationSheets: [],
    allocationSheetsLoading: false,
};
